import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { inverseCountryMap, countries } from '~/utils/countries';

import { Dropdown } from 'tmt-ui-kit';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const DropDownContainer = styled.div`
  z-index: 10;
  margin: 0 12px 12px 0;
  >div {
    >div {
      &:nth-child(4) {
        padding: 0 6px;
      } 
    }
  }
  p {
    line-height: 1;
  }

  @media (max-width: 768px) {
    select {
      height: 34px;
      width: 100%;
      padding-right: 24px;
    }
  }
`;

const SortContainer = styled.div`
  margin: 0 0 12px 0;
  width: 200px;
  p {
    font-size: 13px !important;
    @media (max-width: 768px) {
      font-size: 12px !important;
      padding: 6px 0 0 8px !important;
    }
  }
  @media (max-width: 768px) {
    width: 160px;
  }
`;

const allOptionsFilter = [
  {
    label: 'Most Relevance',
    value: 'relevance'
  },
  {
    label: 'Most Recent',
    value: 'recent',
  },
  {
    label: 'Rating : High to Low',
    value: 'hi-lo',
  },
  {
    label: 'Rating : Low to High',
    value: 'lo-hi'
  }
];

const ReviewFilter = (props) => {
  const { sortBy, onChangeSort, selectedCountry, onChangeCountry, reviews, userCountry, topCountries, userId } = props;
  const reversedTopCountries = topCountries && topCountries.map(c => inverseCountryMap[c]);

  const optionFilter = allOptionsFilter
    .filter(c => {
      if (!userId) {
        return c.value !== 'relevance';
      }
      return c;
    });
  return (
    <Container>
      {(reversedTopCountries && reversedTopCountries.length > 0) && (
        <DropDownContainer>
          <Dropdown.CountryFilterDropdown
            showDefault={selectedCountry === 'all'}
            onChange={(country) => onChangeCountry(country.label)}
            options={countries.filter(c => reversedTopCountries.indexOf(c.value) >= 0)}
            reviews={reviews}
            userCountry={userCountry}
          />
        </DropDownContainer>
      )}
      <SortContainer>
        <Dropdown.Dropdown
          options={optionFilter}
          prefix={['hi-lo', 'lo-hi'].indexOf(sortBy) < 0 ? 'Sort : ' : ''}
          icon="sorting"
          selected={sortBy}
          onChange={onChangeSort}
        />
      </SortContainer>
    </Container>
  );
};

ReviewFilter.propTypes = {
  sortBy: PropTypes.string,
  selectedCountry: PropTypes.string,
  onChangeSort: PropTypes.func,
  onChangeCountry: PropTypes.func,
  reviews: PropTypes.array,
  userCountry: PropTypes.string,
  topCountries: PropTypes.array,
  userId: PropTypes.number
};

export default memo(
  ReviewFilter,
  (prevProps, nextProps) => {
    if (prevProps.sortBy !== nextProps.sortBy) {
      return false;
    }
    if (prevProps.selectedCountry !== nextProps.selectedCountry) {
      return false;
    }
    if (prevProps.topCountries !== nextProps.topCountries) {
      return false;
    }
    return true;
  }
);
